import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';

@Pipe({
  name: 'markdown',
  standalone: true,
})
export class MarkdownPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    // Explicitly force synchronous parse
    const html = marked.parse(value, { async: false }) as string;
    return html.trim().replace(/^<p>([\s\S]*)<\/p>$/i, '$1');
  }
}
